import { Link, createFileRoute, useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import { css } from "../../../styled-system/css";
import { debugLog } from "../../libs/debug-log";

export const Route = createFileRoute("/login/admin")({
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();

  useEffect(() => {
    debugLog("[admin-login] Login page rendered", {
      href: window.location.href,
      pathname: location.pathname,
      search: window.location.search,
      referrer: document.referrer,
    });
  }, [location.pathname, JSON.stringify(location.search)]);

  return (
    <div
      data-panda-theme="v2"
      className={css({
        minH: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bg: "background.primary",
        px: "4",
      })}
    >
      <div
        className={css({
          w: "400px",
          p: "8",
          bg: "white",
          borderRadius: "lg",
          boxShadow: "md",
        })}
      >
        <h1
          className={css({
            fontSize: "2xl",
            fontWeight: "bold",
            textAlign: "center",
            mb: "6",
          })}
        >
          管理者コンソール
        </h1>

        <Link
          to="/admin/companies"
          onClick={() => {
            debugLog("[admin-login] Login link clicked", {
              from: window.location.href,
              to: "/admin/companies",
            });
          }}
          className={css({
            w: "full",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bg: "surface.accentPrimary",
            color: "white",
            py: "2",
            px: "4",
            borderRadius: "md",
            fontWeight: "bold",
            cursor: "pointer",
            _hover: {
              bg: "surface.accentPrimaryHover",
            },
          })}
        >
          ログイン
        </Link>
      </div>
    </div>
  );
}
